import * as React from "react";

import { ToastManager } from "@v1/components/designSystem/alert/Toast";
import { Outlet } from "react-router-dom";

export default function EmptyLayout({ children }: React.PropsWithChildren) {
  return (
    <div className="flex h-screen w-screen flex-col">
      <ToastManager />
      <div className="flex w-full h-full flex-col gap-4 overflow-hidden bg-white">
        <Outlet />
        {children}
      </div>
    </div>
  );
}
